// import { ActionContext } from 'vuex';
// import { StateInterface } from 'src/store';
// import { SocketState } from 'src/store/socket/state';

export function sendMessage() {
  // context: ActionContext<SocketState, StateInterface>,
  // message: WsHandler.Types.Message
  // console.log('sendMessage', { message });
  // WebSocket.sendMessage(message);
}
